import apiClient from "../core/HttpClient";
import { GreetingOccasionCategory } from "../models";
import { GreetingOccasionCategoryViewModel } from "../viewModels";

export default class GreetingOccasionCategoryService{
    url="/GreetingOccasionCategories";

    public async getGreetingOccasionCategories(): Promise<GreetingOccasionCategoryViewModel[]> {
        return await apiClient.get(this.url).then((res) => res.data);
    }

    public async getGreetingOccasionCategoryById(id: number): Promise   <GreetingOccasionCategoryViewModel> {
        return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
    }

    public async createGreetingOccasionCategory(greetingOccasionCategory: GreetingOccasionCategory) {
        return await apiClient.post(this.url, greetingOccasionCategory);
    }

    public async updateGreetingOccasionCategory(greetingOccasionCategory: GreetingOccasionCategory) {
        return await apiClient.put(`${this.url}`, greetingOccasionCategory);
    }

    public async deleteGreetingOccasionCategory(id: number) {
        return await apiClient.delete(`${this.url}/${id}`);
    }
}

